import { Component } from '@angular/core';
import { IChartTileDefinition } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/dashboards/interfaces/tiles/definitions/chart-tile-definition.interface';
import { FilterConditionType } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/filters/filter-condition-type.enum';
import { FilterOperatorType } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/filters/filter-operator-type.enum';
import { chartColors } from '../../../../../shared/const/chart-colors.const';

@Component({
  selector: 'app-analyst-report',
  template: `
    <div style="margin-bottom: 22px">
      @for (tileInstance of tileInstances; track tileInstance) {
        <suvo-bi-tile-wrapper [tileInstance]="tileInstance" />
      }
    </div>
  `,
})
export class AnalystReportComponent {
  tileInstances: Array<IChartTileDefinition> = [
    {
      tileType: 'chart',
      chartType: {
        value: 'bar-vertical',
      },
      title: 'Unsubmitted Samples per Analyst',
      recipe: {
        fullRoute: 'sample-reports',
        groupBy: 'userId',
        groupLabelField: 'legacyAnalystId',
        metric: 'count',
        maxGroups: 20,
        includeOtherGroup: true,
        filters: {
          name: 'report filters',
          query: {
            op: FilterOperatorType.And,
            rules: [
              {
                key: 'submittedAt',
                con: [{ type: FilterConditionType.NotExists }],
              },
              {
                key: 'user.legacyAnalystId',
                neq: 99,
              },
            ],
          },
        },
      },
      chartColors: [chartColors[2]],
      canView: true,
      hideLegend: true,
    },
    {
      tileType: 'chart',
      chartType: {
        value: 'bar-vertical',
      },
      title: 'Unresolved checkblocks per Analyst',
      recipe: {
        fullRoute: 'check-block-reports',
        groupBy: 'sample.userId',
        groupLabelField: 'legacyAnalystId',
        metric: 'count',
        maxGroups: 20,
        includeOtherGroup: true,
        filters: {
          name: 'report filters',
          query: {
            op: FilterOperatorType.And,
            rules: [
              {
                op: FilterOperatorType.Or,
                rules: [
                  {
                    key: 'resolved',
                    con: [{ type: FilterConditionType.Equals, val: false }],
                  },
                  {
                    key: 'resolved',
                    con: [{ type: FilterConditionType.NotExists }],
                  },
                ],
              },
              {
                key: 'sampleUser.legacyAnalystId',
                neq: 99,
              },
            ],
          },
        },
      },
      chartColors: [chartColors[4]],
      canView: true,
      hideLegend: true,
    },
  ];
}
